import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const About = ({ profileData }) => {
  const [showModal, setShowModal] = useState(false);


  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  console.log(profileData);
  const aboutText =   profileData?.about || '';
  // const displayText = aboutText.length > 150 ? `${aboutText?.substring(0, 150)}...` : aboutText;
  // const displayText =  aboutText;

const experience = (() => {
  const years = profileData?.year_experience;
  if (!years || years === 0) return "No experience";
  if (years === 1) return "1 year";
  if (years === 2) return "2 years";
  return `${years} years`;
})();
  // const activeJob = profileData?.active_job || "No Job";
const activeJob = profileData?.active_job
  ? [
      profileData.active_job.title,
      profileData.active_job.joining_date,
      profileData.active_job.company,
    ]
      .filter(Boolean) // remove undefined/null/empty strings
      .join(" | ")
  : "No Job";

  const education = profileData?.education || "Masters in Art and Filming"; // You can replace this if dynamic

const skills = profileData?.skill_id?.title || "";
 const displayText =
    aboutText?.length > 150 ? aboutText.substring(0, 150) + "..." : aboutText;
   const { t, i18n } = useTranslation();
  
       const isRTL = i18n.language === 'ar';
  return (
    <div>
      <p
        className="inter-font"
        style={{ fontSize: "15px", marginTop: "4rem", color: "#939393" }}
      >
        {displayText}
        {aboutText?.length > 150 && (
          <span
            className="text-danger inter-font"
            style={{ cursor: "pointer" }}
            onClick={handleShow}
          >
            Read More
          </span>
        )}
      </p>

{/* Modal for full about section */}
{/* Modal for full about section */}
<Modal
  show={showModal}
  onHide={handleClose}
  centered
  size="lg"
  dir={isRTL ? "rtl" : "ltr"} // Set direction based on language
>
  <Modal.Header 
    closeButton 
    style={{ 
      background: "#F8F9FA",
      direction: isRTL ? "rtl" : "ltr"
    }}
  >
    <Modal.Title 
      className="inter-font fw-semibold" 
      style={{ 
        textAlign: isRTL ? "right" : "left",
        width: "100%"
      }}
    >
      {t("new_text_27")} {/* About */}
    </Modal.Title>
  </Modal.Header>
  
  <Modal.Body style={{ 
    background: "#FFF",
    direction: isRTL ? "rtl" : "ltr"
  }}>
    <p
      className="inter-font"
      style={{ 
        fontSize: "14px", 
        color: "#595959",
        textAlign: isRTL ? "right" : "left",
        direction: "ltr",
        unicodeBidi: "plaintext"
      }}
    >
      {aboutText}
    </p>

    <div className="row mt-4">
      <div className="col-md-6 mb-3">
        <strong 
          className="inter-font" 
          style={{ 
            fontSize: "16px",
            textAlign: isRTL ? "right" : "left",
            display: "block"
          }}
        >
          {t("t_my_Profile_tab1_text1")} {/* Experience */}
        </strong>
        <p
          className="inter-font"
          style={{ 
            fontSize: "14px", 
            color: "#939393",
            direction: "ltr",
            unicodeBidi: "plaintext",
            textAlign: isRTL ? "right" : "left"
          }}
        >
          {experience} 
        </p>
      </div>

      <div className="col-md-6 mb-3">
        <strong 
          className="inter-font" 
          style={{ 
            fontSize: "16px",
            textAlign: isRTL ? "right" : "left",
            display: "block"
          }}
        >
          {t("t_my_Profile_tab1_text2")} {/* Education and Certification */}
        </strong>
        <p
          className="inter-font"
          style={{ 
            fontSize: "14px", 
            color: "#939393",
            direction: "ltr",
            unicodeBidi: "plaintext",
            textAlign: isRTL ? "right" : "left"
          }}
        >
          {education}
        </p>
      </div>

      <div className="col-md-6 mb-3">
        <strong 
          className="inter-font" 
          style={{ 
            fontSize: "16px",
            textAlign: isRTL ? "right" : "left",
            display: "block"
          }}
        >
          {t("t_my_Profile_tab1_text3")} {/* Skills Area */}
        </strong>
        <p
          className="inter-font"
          style={{ 
            fontSize: "14px", 
            color: "#939393",
            direction: "ltr",
            unicodeBidi: "plaintext",
            textAlign: isRTL ? "right" : "left"
          }}
        >
          {skills}
        </p>
      </div>

      <div className="col-md-6 mb-3">
        <strong 
          className="inter-font" 
          style={{ 
            fontSize: "16px",
            textAlign: isRTL ? "right" : "left",
            display: "block"
          }}
        >
          {t("t_my_Profile_tab1_text4")} {/* Active Job */}
        </strong>
        <p
          className="inter-font"
          style={{ 
            fontSize: "14px", 
            color: "#939393",
            direction: "ltr",
            unicodeBidi: "plaintext",
            textAlign: isRTL ? "right" : "left"
          }}
        >
          {activeJob}
        </p>
      </div>
    </div>
  </Modal.Body>
  
  <Modal.Footer style={{ 
    background: "#F8F9FA",
    direction: isRTL ? "rtl" : "ltr"
  }}>
    <Button
      style={{
        backgroundColor: "#e15d4f",
        color: "#fff",
        border: "none",
      }}
      onClick={handleClose}
    >
      {t("c_t_close")} {/* Close */}
    </Button>
  </Modal.Footer>
</Modal>

      {/* Info Grid (outside modal) */}
      <div className="row mt-4">
        <div className="col-md-6 my-3">
          <strong
            className="inter-font"
            style={{ fontSize: "16px", color: "#595959" }}
          >
            {t("t_my_Profile_tab1_text1")}
          </strong>
          <p
            className="mb-0 inter-font"
            style={{ fontSize: "14px", color: "#939393" }}
          >
            {experience}
          </p>
        </div>

        <div className="col-md-6 my-3">
          <strong
            className="inter-font"
            style={{ fontSize: "16px", color: "#595959" }}
          >
            {t("t_my_Profile_tab1_text2")}
          </strong>
          <p
            className="mb-0 inter-font"
            style={{ fontSize: "14px", color: "#939393" }}
          >
            {education}
          </p>
        </div>

        <div className="col-md-6 my-3">
          <strong
            className="inter-font"
            style={{ fontSize: "16px", color: "#595959" }}
          >
            {t("t_my_Profile_tab1_text3")}
          </strong>
          <p
            className="mb-0 inter-font"
            style={{ fontSize: "14px", color: "#939393" }}
          >
            {profileData?.skill_id?.title}
          </p>
        </div>

        <div className="col-md-6 my-3">
          <strong
            className="inter-font"
            style={{ fontSize: "16px", color: "#595959" }}
          >
            {t("t_my_Profile_tab1_text4")}
          </strong>
          <p
            className="mb-0 inter-font"
            style={{ fontSize: "14px", color: "#939393" }}
          >
            {activeJob}
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
